var map = {
	"./holiday_1/tabicon_0.png": "0a99",
	"./holiday_1/tabicon_1.png": "06d5",
	"./holiday_1/tabicon_10.png": "6144",
	"./holiday_1/tabicon_2.png": "0c28",
	"./holiday_1/tabicon_3.png": "a846",
	"./holiday_1/tabicon_4.png": "dc95",
	"./holiday_1/tabicon_5.png": "d817",
	"./holiday_1/tabicon_6.png": "44ca",
	"./holiday_1/tabicon_7.png": "bc4c",
	"./holiday_1/tabicon_8.png": "efa1",
	"./holiday_1/tabicon_9.png": "8219"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5bd8";